import React from "react";
import Layout from "../components/Layout/Layout";
import Products from "../components/Products";
import "./Games.css";

const Games = () => {
  return (
    <Layout>
      <main className="gamesPage">
        <section className="gamesHeroBand">
          <div className="gamesHeroInner">
            <span className="gamesEyebrow">Instant Top Up</span>
            <h1>Find Your Game</h1>
            <p>Browse all available games and services in one place.</p>
          </div>
        </section>

        <Products
          title="All Games"
          forceTitle
          showRecent={false}
          showQuickActions={false}
        />
      </main>
    </Layout>
  );
};

export default Games;
